import styled from 'styled-components';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import Button from '@userzoomlibraries/toolkit-button';
import Icon from '@userzoomlibraries/toolkit-icon';
import noop from '@userzoomlibraries/toolkit-js-utils/noop';
import { f as fallbackCloseIcon } from './index2.js';
import { jsx } from 'react/jsx-runtime';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var CloseButton$1 = function CloseButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;

  var onClickHandler = function onClickHandler(event) {
    onClick(event);
  };

  return /*#__PURE__*/jsx(Button, {
    "aria-label": "Close",
    className: "gz-dialog__close-button ".concat(className),
    onClick: onClickHandler,
    children: /*#__PURE__*/jsx(Icon, {
      name: "close",
      fallback: fallbackCloseIcon
    })
  });
};

CloseButton$1.COMPONENT_ID = 'Gearz.RelativeDialog.CloseButton';
CloseButton$1.displayName = CloseButton$1.COMPONENT_ID;
CloseButton$1.propTypes = {
  className: PropTypes.stringWithDescription('Custom class to be applied.'),
  onClick: PropTypes.funcWithDescription('Callback called when click event is triggered.')
};
CloseButton$1.defaultProps = {
  className: '',
  onClick: noop
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var CloseButton = styled(CloseButton$1).withConfig({
  componentId: "gz-dialog-1674727614741__sc-pvje5h-0"
})(["align-items:center;background-color:transparent;border:none;border-radius:6px;display:flex;height:32px;justify-content:center;padding:0;position:absolute;right:0.5rem;top:0.5rem;transition:all 250ms ease 0s;width:32px;&:focus{box-shadow:0 0 0 3px rgba(49,79,255,0.25);}&:hover{background-color:rgba(0,0,0,0.06);}&:active{background-color:rgba(0,0,0,0.08);}.gz-icon{height:12px;width:12px;}"]);
CloseButton.propTypes = CloseButton$1.propTypes;
CloseButton.defaultProps = CloseButton$1.defaultProps;

export { CloseButton as C };
